import { Chip, Stack, Typography } from "@mui/material";
import type { TagSelectItem } from "../fileDetailsHelper";

interface Props {
  fileTags: TagSelectItem[];
}

const FileTagsSection = ({ fileTags }: Props) => {
  return (
    <Stack spacing={1.5}>
      <Typography variant="subtitle1">Tags</Typography>
      <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap", rowGap: 1 }}>
        {fileTags.length === 0 ? (
          <Typography color="textSecondary">No tags yet</Typography>
        ) : (
          fileTags.map(({ id, label }) => <Chip variant="outlined" key={id} label={label} />)
        )}
      </Stack>
    </Stack>
  );
};

export default FileTagsSection;
